/* Original Rivonella enhancement: assistance link only. Wokiee owns media and purchase state. */
(() => {
  if (customElements.get('rivonella-whatsapp-product')) return;
  class RivonellaWhatsAppProduct extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.scope = this.closest('section[data-product-handle]') || this.closest('.shopify-section');
      this.link = this.querySelector('.rv-product-help__button');
      try {
        this.variants = JSON.parse(this.querySelector('[data-rv-variants]').textContent);
      } catch (_) {
        return; // Keep the server-rendered contact link usable.
      }
      const listenerOptions = { signal: this.events.signal };
      this.scope?.addEventListener('change', () => this.refresh(), listenerOptions);
      this.link?.addEventListener('click', () => this.refresh(), listenerOptions);
      this.link?.addEventListener('contextmenu', () => this.refresh(), listenerOptions);
      this.refresh();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }

    selection() {
      const picker = this.scope?.querySelector('variant-selects');
      const groups = picker ? [...picker.querySelectorAll('.product-form__input')] : [];
      if (groups.length) {
        const values = groups.map((group) => group.querySelector('input[type="radio"]:checked, select')?.value);
        return this.variants.find((variant) => variant.options.length === values.length && variant.options.every((value, i) => value === values[i])) || null;
      }
      const productForm = this.scope?.querySelector(`[id="product-form-${this.dataset.sectionId}"]`);
      const selectedId = productForm?.querySelector('input[name="id"]')?.value || this.dataset.variantId;
      return this.variants.find((variant) => String(variant.id) === String(selectedId)) || null;
    }

    refresh() {
      if (!this.link || !this.variants) return;
      const variant = this.selection();
      const url = new URL(this.dataset.url, window.location.origin);
      url.search = '';
      url.hash = '';
      if (variant) url.searchParams.set('variant', variant.id);
      const title = this.dataset.title + (variant && variant.title !== 'Default Title' ? ` — ${variant.title}` : '');
      const number = (this.dataset.number || '393511063226').replace(/\D/g, '');
      const message = `Ciao Rivonella, vorrei informazioni su ${title}: ${url.href}`;
      this.link.href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    }
  }
  customElements.define('rivonella-whatsapp-product', RivonellaWhatsAppProduct);
})();
